// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Profile_overlay__1t1Q9 {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
}

.Profile_dropdown__6pmtS {
  position: absolute;
  top: 70px;
  right: 20px;
  width: 320px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  padding: 16px;
}

@media (max-width: 900px) {
  .Profile_overlay__1t1Q9 {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.7);
  }

  .Profile_dropdown__6pmtS {
    position: relative;
    top: 0;
    right: 0;
    width: 90%;
    max-width: 400px;
    margin: 20px;
  }
}



.Profile_header__dlU2R {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.Profile_walletInfo__QndwQ {
  display: flex;
  align-items: center;
  gap: 12px;
}

.Profile_iconWrapper__qxRgo {
  width: 40px;
  height: 40px;
  background: #000000;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.Profile_chainIcon__LgDxj {
  width: 24px;
  height: 24px;
}

.Profile_walletDetails__AncGq {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.Profile_walletLabel__1mRFt {
  font-size: 16px;
  font-weight: 600;
  color: #000;
}

.Profile_walletAddress__BIFPY {
  font-size: 14px;
  color: #666;
}

.Profile_networkBadge__9e97h {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background: #f5f5f5;
  border-radius: 20px;
  font-size: 14px;
  color: #000;
}

.Profile_networkIcon__\\+-306 {
  width: 16px;
  height: 16px;
}

.Profile_balanceSection__VxW6w {
  padding: 16px 0;
  border-top: 1px solid #eee;
  border-bottom: 1px solid #eee;
  margin-bottom: 16px;
}

.Profile_balanceLabel__GD\\+z7 {
  font-size: 14px;
  color: #666;
  margin-bottom: 4px;
}

.Profile_balanceAmount__DsqOw {
  font-size: 20px;
  font-weight: 600;
  color: #000;
}

.Profile_logoutButton__eneGG {
  width: 100%;
  padding: 12px;
  background: #000000;
  border: 1px solid #eee;
  color: #ffffff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.Profile_logoutButton__eneGG:hover {
  opacity: 0.7;
}

.Profile_actionGroup__mfoOK {
  display: flex;
  align-items: center;
  gap: 12px;
}

.Profile_closeButton__r3Z2k {
    padding: 0;
    margin: 0;
    background: transparent;
    border: none;
}

@media (min-width: 900px) {
    .Profile_closeButton__r3Z2k {
        display: none;
        padding: 0;
        margin: 0;
        background: transparent;
        border: none;
        cursor: pointer;
        color: #666;
    }
}



`, "",{"version":3,"sources":["webpack://./src/pages/dappPages/components/Profile/Profile.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,yCAAyC;EACzC,aAAa;AACf;;AAEA;EACE;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,oCAAoC;EACtC;;EAEA;IACE,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,UAAU;IACV,gBAAgB;IAChB,YAAY;EACd;AACF;;;;AAIA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;IACI,UAAU;IACV,SAAS;IACT,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI;QACI,aAAa;QACb,UAAU;QACV,SAAS;QACT,uBAAuB;QACvB,YAAY;QACZ,eAAe;QACf,WAAW;IACf;AACJ","sourcesContent":[".overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 1000;\n}\n\n.dropdown {\n  position: absolute;\n  top: 70px;\n  right: 20px;\n  width: 320px;\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  padding: 16px;\n}\n\n@media (max-width: 900px) {\n  .overlay {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background-color: rgba(0, 0, 0, 0.7);\n  }\n\n  .dropdown {\n    position: relative;\n    top: 0;\n    right: 0;\n    width: 90%;\n    max-width: 400px;\n    margin: 20px;\n  }\n}\n\n\n\n.header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.walletInfo {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.iconWrapper {\n  width: 40px;\n  height: 40px;\n  background: #000000;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.chainIcon {\n  width: 24px;\n  height: 24px;\n}\n\n.walletDetails {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n\n.walletLabel {\n  font-size: 16px;\n  font-weight: 600;\n  color: #000;\n}\n\n.walletAddress {\n  font-size: 14px;\n  color: #666;\n}\n\n.networkBadge {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  background: #f5f5f5;\n  border-radius: 20px;\n  font-size: 14px;\n  color: #000;\n}\n\n.networkIcon {\n  width: 16px;\n  height: 16px;\n}\n\n.balanceSection {\n  padding: 16px 0;\n  border-top: 1px solid #eee;\n  border-bottom: 1px solid #eee;\n  margin-bottom: 16px;\n}\n\n.balanceLabel {\n  font-size: 14px;\n  color: #666;\n  margin-bottom: 4px;\n}\n\n.balanceAmount {\n  font-size: 20px;\n  font-weight: 600;\n  color: #000;\n}\n\n.logoutButton {\n  width: 100%;\n  padding: 12px;\n  background: #000000;\n  border: 1px solid #eee;\n  color: #ffffff;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.logoutButton:hover {\n  opacity: 0.7;\n}\n\n.actionGroup {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.closeButton {\n    padding: 0;\n    margin: 0;\n    background: transparent;\n    border: none;\n}\n\n@media (min-width: 900px) {\n    .closeButton {\n        display: none;\n        padding: 0;\n        margin: 0;\n        background: transparent;\n        border: none;\n        cursor: pointer;\n        color: #666;\n    }\n}\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `Profile_overlay__1t1Q9`,
	"dropdown": `Profile_dropdown__6pmtS`,
	"header": `Profile_header__dlU2R`,
	"walletInfo": `Profile_walletInfo__QndwQ`,
	"iconWrapper": `Profile_iconWrapper__qxRgo`,
	"chainIcon": `Profile_chainIcon__LgDxj`,
	"walletDetails": `Profile_walletDetails__AncGq`,
	"walletLabel": `Profile_walletLabel__1mRFt`,
	"walletAddress": `Profile_walletAddress__BIFPY`,
	"networkBadge": `Profile_networkBadge__9e97h`,
	"networkIcon": `Profile_networkIcon__+-306`,
	"balanceSection": `Profile_balanceSection__VxW6w`,
	"balanceLabel": `Profile_balanceLabel__GD+z7`,
	"balanceAmount": `Profile_balanceAmount__DsqOw`,
	"logoutButton": `Profile_logoutButton__eneGG`,
	"actionGroup": `Profile_actionGroup__mfoOK`,
	"closeButton": `Profile_closeButton__r3Z2k`
};
export default ___CSS_LOADER_EXPORT___;
